import {
  LIST_USERS_RESPONSE,
  FETCH_USER_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// userId -> {user}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_USERS_RESPONSE: {
      const s = { ...state }
      const users = action.users || []
      users.forEach((u) => {
        s[u.user_id] = {
          ...u,
          isLoading: false,
        }
      })
      return s
    }
    case FETCH_USER_RESPONSE: {
      const s = { ...state }
      s[action.user.user_id] = action.user
      if (action.id && action.id !== action.user.user_id) {
        s[action.id] = action.user
      }
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
